import { useEffect, useState } from "react";
import { IColumns, IUsers } from "../user.interface";
import { StatusCodes } from "http-status-codes";
import moment from "moment";
import Switch from "react-switch";
import {
  ChangeUserStatusService,
  DeleteUserService,
  GetUsersService,
} from "../../../services/user.service";
import { toast } from "react-toastify";
import Paginate from "../../../components/Paginate";
import TableLoader from "../../../components/TableLoader";
import { Roles } from "../../../types/role.enums";
import { useNavigate } from "react-router-dom";
const Users = () => {
  let limit = 10;
  const [users, setUsers] = useState<IUsers>();
  const [page, setPage] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const GetUsers = async (pageNumber: number) => {
    setLoading(true);
    const response = await GetUsersService(pageNumber, limit);
    if (response.status && response.status_code === StatusCodes.OK) {
      setUsers(response.data);
    }
    setLoading(false);
  };
  let columns: any = [
    {
      title: "Name",
      key: "name",
    },
    {
      title: "Company",
      key: "company",
    },
    {
      title: "City",
      key: "city",
    },
    {
      title: "State",
      key: "state",
    },
    {
      title: "Email",
      key: "email",
    },
    {
      title: "Phone",
      key: "phone",
    },
    {
      title: "Status",
      key: "verified",
    },
    {
      title: "Creation date",
      key: "creation date",
    },
    {
      title: "Action",
      key: "action",
    },
  ];
  useEffect(() => {
    GetUsers(page);
  }, [page]);


  const handleDeleteUser = async (userId: number) => {
    if (window.confirm("Are you sure you want to delete user?")) {
      const response = await DeleteUserService(userId);
      if (response.status && response.status_code === StatusCodes.OK) {
        toast.success(response.message);
        await GetUsers(page);
      }
    }
  };
  const handleChangeType = async (type: string) => {
    let ob: any = { type: type };
    setLoading(true);
    const response = await GetUsersService(page, limit, ob);
    if (response.status && response.status_code === StatusCodes.OK) {
      setUsers(response.data);
    }
    setLoading(false);
  };

  const handleChangeUserStatus = async (checked: any, user_id: any) => {
    const response = await ChangeUserStatusService({
      status: checked ? "1" : "0",
      id: user_id,
    });
    if (response.status && response.status_code === StatusCodes.OK) {
      toast.success(response.message);
    }
    await GetUsers(page);
  };
  const navigate = useNavigate()
  return loading ? (
    <TableLoader />
  ) : (
    <>
      <div className="flex gap-4 items-center justify-center">
        <span
          onClick={() => handleChangeType("auctioners")}
          className="underline text-blue-500 cursor-pointer"
        >
          Auctioners
        </span>
        <span
          onClick={() => handleChangeType("admin")}
          className="underline text-blue-500 cursor-pointer"
        >
          Administrators
        </span>
      </div>
      <table className="mt-4 w-15">
        <thead>
          <tr>
            {columns.map((column: any) => {
              return (
                <th align="left" key={column.key}>
                  {column.title}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {users?.data?.map((row, index) => {
            return (
              <tr
                key={index}
                className={`${index % 2 === 0 ? "bg-pink-50" : ""}`}
              >
                <td align="left">{row?.first_name}</td>
                <td align="left">{row?.user_profile?.company_name}</td>
                <td align="left">{row?.user_profile?.city}</td>
                <td align="left">{row?.user_profile?.state}</td>
                <td align="left">{row.email}</td>
                <td align="left">{row?.mobile_number}</td>
                <td align="left">
                  {row.status === "1" ? "Active" : "InActive"}
                </td>
                <td align="left">
                  {moment(row.created_at).format("MM/DD/YYYY")}
                </td>
                {row.role_name === Roles.SUPER_ADMIN ? null : (
                  <td className="flex items-center ml-2" align="left">
                    <button
                      onClick={() => navigate(`/admin/user-profile/${row.id}`)}
                      className="border-2 px-1 border-gray-600 bg-gray-400"
                    >
                      edit
                    </button>
                    &nbsp;
                    <button
                      onClick={() => handleDeleteUser(row.user_profile.user_id)}
                      className="border-2 px-1 border-gray-600 bg-gray-400"
                    >
                      delete
                    </button>
                    &nbsp;
                    <Switch
                      className="mt-2"
                      id={row.id}
                      onChange={(checked) =>
                        handleChangeUserStatus(checked, row.id)
                      }
                      checked={row?.status === "1" ? true : false}
                    />
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      <Paginate total_pages={users?.links!} page={page} setPage={setPage} />
    </>
  );
};

export default Users;
